module.exports = __webpack_public_path__ + "admin/img/upgrade_success.29499ee1.png";